import "antd/lib/switch/style";
import _Switch from "antd/lib/switch";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/select/style";
import _Select from "antd/lib/select";
import "antd/lib/upload/style";
import _Upload from "antd/lib/upload";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/modal/style";
import _Modal from "antd/lib/modal"; /*@通用组件-头部导航栏*/ /**
                                                     * 默认的表格头部筛选栏组件
                                                     * API:
                                                     *       hasAdd: PropTypes.bool. 是否有添加按钮
                                                     *       hasDelete: PropTypes.bool. 是否有批量删除按钮
                                                     hasSearch: PropTypes.bool. 是否有搜索输入框
                                                     hasUpload: PropTypes.bool. 是否有上传按钮
                                                     inputPlaceHolder: PropTypes.string. 搜索输入框的placeholder
                                                     add: PropTypes.func.   添加按钮点击后的回调
                                                     delete: PropTypes.func. 批量删除按钮点击后的回调
                                                     submit: PropTypes.func.  搜索框点击搜索后的回调
                                                     hasSelect: PropTypes.bool. 是否有第一个下拉框
                                                     hasSelectTwo: PropTypes.bool. 是否有第二个下拉框
                                                     hasSelectThree: PropTypes.bool. 是否有第三个下拉框
                                                     hasSelectThree: PropTypes.bool. 是否有第四个下拉框
                                                     options: PropTypes.array.  第一个下拉框列表
                                                     optionsTwo: PropTypes.array.
                                                     optionsThree: PropTypes.array.
                                                     optionsFour: PropTypes.array.
                                                     selectOneMethod: PropTypes.func.
                                                     selectTwoMethod: PropTypes.func.
                                                     selectThreeMethod: PropTypes.func.
                                                     selectFourMethod: PropTypes.func.
                                                     selectPlaceHolder: PropTypes.string.
                                                     selectTwoPlaceHolder: PropTypes.string.
                                                     selectThreePlaceHolder: PropTypes.string.
                                                     selectFourPlaceHolder: PropTypes.string.
                                                     uploadUrl: PropTypes.string. 上传按钮所需URL
                                                     uploadData: PropTypes.object.  上传所需额外参数
                                                     hasModalStyelUpload: PropTypes.bool.   是否需要弹窗形式的上传交互
                                                     modal: PropTypes.func.
                                                     addAlias: PropTypes.string.
                                                     addBtnDisabled: PropTypes.bool.
                                                     hasExtraBtn: PropTypes.bool.
                                                     extraBtnName: PropTypes.string.
                                                     extraSelectedKeys: PropTypes.array.
                                                     hasExtraBtnTwo: PropTypes.bool.
                                                     showExtraConfirmTwo: PropTypes.bool.
                                                     extraBtnNameTwo: PropTypes.string.
                                                     selectedKeys: PropTypes.array.
                                                     extraConfirmMethodTwo: PropTypes.func.
                                                     extraConfirmMethod: PropTypes.func.
                                                     confirmTitleTwo: PropTypes.string.
                                                     confirmTitle: PropTypes.string.
                                                     confirmContent: PropTypes.string.
                                                     confirmContentTwo: PropTypes.string.
                                                     hasExtraBtnThree: PropTypes.bool.
                                                     btnThreeFunc: PropTypes.func.
                                                     extraBtnNameThree: PropTypes.string.
                                                     hasSelectFour: PropTypes.bool.
                                                     * */
import React from 'react';
import "./HeaderBar.scss";
import { injectIntl } from 'react-intl';
var confirm = _Modal.confirm;
var RangePicker = _DatePicker.RangePicker,
  MonthPicker = _DatePicker.MonthPicker;
var selectionDefaultWidth = 150;
var HeaderBar = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderBar, _React$Component);
  function HeaderBar(props) {
    var _this;
    _classCallCheck(this, HeaderBar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeaderBar).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showDeleteConfirm", function () {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      if (_this.props.selectedKeys.length > 0) {
        confirm({
          title: "Are you sure you want to delete the selected item?",
          content: _this.props.hasDeleteContent ? "Only disabled data can be deleted" : _this.props.deleteContent ? _this.props.deleteContent : '',
          onOk: function onOk() {
            vm.props["delete"]();
          }
        });
      } else {
        _Modal.warning({
          title: "Please select at least one item"
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showExtraConfirmTwo", function () {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      if (_this.props.selectedKeys.length > 0) {
        confirm({
          title: _this.props.confirmTitleTwo,
          content: _this.props.confirmContentTwo,
          onOk: function onOk() {
            vm.props.extraConfirmMethodTwo();
          }
        });
      } else {
        _Modal.warning({
          title: "Please select at least one item"
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showExtraConfirm", function () {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      if (_this.props.selectedKeys.length > 0) {
        confirm({
          title: _this.props.confirmTitle,
          content: _this.props.confirmContent,
          onOk: function onOk() {
            vm.props.extraConfirmMethod();
          }
        });
      } else {
        _Modal.warning({
          title: "Please select at least one item"
        });
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchContentChange", function (name, e, callback) {
      var value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
      _this.setState(_defineProperty({}, name, value.trim()), function () {
        if (value === "") {
          callback(value);
        }
      });
    });
    _this.state = {
      searchValue: _this.props.searchValue ? _this.props.searchValue : '',
      searchValueOne: ""
    };
    return _this;
  }
  _createClass(HeaderBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("header", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-header"
      }, this.props.hasAdd ? /*#__PURE__*/React.createElement(_Button, {
        icon: "file-add",
        style: {
          marginRight: 8
        },
        onClick: this.props.add,
        disabled: this.props.addBtnDisabled
      }, this.props.addAlias || "add to") : "", this.props.hasAddTwo ? /*#__PURE__*/React.createElement(_Button, {
        icon: this.props.addTwoIcon ? this.props.addTwoIcon : 'file-add',
        style: {
          marginRight: 8
        },
        onClick: this.props.addTwo,
        disabled: this.props.addBtnDisabledTwo
      }, this.props.addAliasTwo || "add to") : "", this.props.hasDelete ? /*#__PURE__*/React.createElement(_Button, {
        style: {
          marginRight: 8
        },
        icon: "delete",
        onClick: this.showDeleteConfirm,
        disabled: this.props.addDeleteDisabled
      }, "Batch deletion") : "", this.props.hasUpload ? /*#__PURE__*/React.createElement(_Upload, {
        action: this.props.uploadUrl,
        data: this.props.uploadData
      }, /*#__PURE__*/React.createElement(_Button, {
        icon: "folder-add"
      }, "Batch upload")) : "", this.props.hasModalStyelUpload ? /*#__PURE__*/React.createElement(_Button, {
        style: {
          marginRight: 8
        },
        onClick: this.props.modal,
        icon: "folder-add"
      }, "Batch upload") : "", this.props.hasExtraBtn ? /*#__PURE__*/React.createElement(_Button, {
        onClick: this.showExtraConfirm,
        style: {
          marginRight: 8
        }
      }, this.props.extraBtnName) : "", this.props.hasExtraBtnTwo ? /*#__PURE__*/React.createElement(_Button, {
        onClick: this.showExtraConfirmTwo,
        style: {
          marginRight: 8
        },
        disabled: this.props.extraBtnDisabledTwo
      }, this.props.extraBtnNameTwo) : "", this.props.hasExtraBtnThree ? /*#__PURE__*/React.createElement(_Button, {
        onClick: this.props.btnThreeFunc,
        disabled: this.props.extraBtnDeleteDisabledThree,
        style: {
          marginRight: 8
        }
      }, this.props.extraBtnNameThree) : "", this.props.hasExtraBtnFour ? /*#__PURE__*/React.createElement(_Button, {
        onClick: this.props.btnFourFunc,
        disabled: this.props.extraBtnDisabledFour,
        style: {
          marginRight: 8
        }
      }, this.props.extraBtnNameFour) : "", this.props.hasDownload ? /*#__PURE__*/React.createElement(_Button, {
        style: {
          marginRight: 8
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: this.props.downloadUrl
      }, this.props.downloadBtnNm)) : "", this.props.extraSlot), this.props.hasSearch ? /*#__PURE__*/React.createElement("div", {
        className: "right-header"
      }, this.props.extraSlotForRight, this.props.hasLink ? /*#__PURE__*/React.createElement("span", {
        className: "common-link-icon mr10",
        onClick: this.props.linkClick
      }, this.props.linkName) : '', this.props.hasDataPickerTwo ? /*#__PURE__*/React.createElement("span", {
        style: {
          width: 210,
          marginRight: 8
        }
      }, /*#__PURE__*/React.createElement(MonthPicker, {
        style: {
          width: 100,
          marginRight: 8
        },
        onChange: this.props.monthPickerMethod,
        allowClear: !this.props.notallowClearmonth,
        defaultValue: this.props.monthRange
      }), /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 351
        },
        showTime: this.props.rangePickerShowTime,
        onChange: this.props.rangePickerMethod,
        allowClear: true,
        disabledDate: this.props.disabledDate,
        key: this.props.key,
        defaultValue: this.props.dateRange
      })) : "", this.props.hasRangePicker ? /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 210,
          marginRight: 8
        },
        showTime: this.props.rangePickerShowTime,
        onChange: this.props.rangePickerMethod,
        allowClear: !this.props.notAllowedClearForRangePicker,
        disabledDate: this.props.disabledDate,
        defaultValue: this.props.dateRange
      }) : "", this.props.hasMonthPicker ? /*#__PURE__*/React.createElement(MonthPicker, {
        style: {
          width: 210,
          marginRight: 8
        },
        onChange: this.props.monthPickerMethod,
        allowClear: true,
        defaultValue: this.props.monthRange,
        format: this.props.monthFormat
      }) : "", this.props.hasSelect ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectOneWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectPlaceHolder,
        onChange: this.props.selectOneMethod,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        allowClear: !this.props.notAllowedClearForOne,
        defaultValue: this.props.selectOneDefaultValue || undefined
      }, this.props.selectOneProps), this.props.options) : "", this.props.hasSelectTwo ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectTwoWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectTwoPlaceHolder,
        onChange: this.props.selectTwoMethod,
        allowClear: true,
        defaultValue: this.props.selectTwoDefaultValue || undefined,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
      }, this.props.selectTwoProps), this.props.optionsTwo) : "", this.props.hasSelectThree ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectThreeWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectThreePlaceHolder,
        onChange: this.props.selectThreeMethod,
        allowClear: true,
        defaultValue: this.props.selectThreeDefaultValue || undefined,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
      }, this.props.selectThreeProps), this.props.optionsThree) : "", this.props.hasSelectFour ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectFourWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectFourPlaceHolder,
        onChange: this.props.selectFourMethod,
        allowClear: true,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        defaultValue: this.props.selectFourDefaultValue || undefined
      }, this.props.selectFourProps), this.props.optionsFour) : "", this.props.hasSelectFive ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectFiveWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectFivePlaceHolder,
        onChange: this.props.selectFiveMethod,
        allowClear: true,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        defaultValue: this.props.selectFiveDefaultValue || undefined
      }, this.props.selectFiveProps), this.props.optionsFive) : "", this.props.hasSelectSix ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectSixWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectSixPlaceHolder,
        onChange: this.props.selectSixMethod,
        allowClear: true,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        defaultValue: this.props.selectSixDefaultValue || undefined
      }, this.props.selectSixProps), this.props.optionsSix) : "", this.props.hasSelectSeven ? /*#__PURE__*/React.createElement(_Select, Object.assign({
        style: {
          width: this.props.selectSevenWidth || selectionDefaultWidth,
          marginRight: 8
        },
        placeholder: this.props.selectSevenPlaceHolder,
        onChange: this.props.selectSevenMethod,
        allowClear: true,
        showSearch: true,
        filterOption: function filterOption(input, option) {
          return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        defaultValue: this.props.selectSevenDefaultValue || undefined
      }, this.props.selectSevenProps), this.props.optionsSeven) : "", this.props.hasInput ? /*#__PURE__*/React.createElement(_Input, {
        style: {
          width: this.props.searchInputWidthOne || 160,
          marginRight: 8
        },
        placeholder: this.props.inputPlaceHolderOne || "Please enter keywords",
        onChange: function onChange(e) {
          return _this2.handleSearchContentChange('searchValueOne', e, _this2.props.submitOne);
        },
        onPressEnter: function onPressEnter() {
          return _this2.props.submitOne(_this2.state.searchValueOne);
        },
        name: "fakepasswordremembered"
      }) : '', this.props.hasNotSearchInput ? "" : /*#__PURE__*/React.createElement(_Input, Object.assign({
        style: {
          width: this.props.searchInputWidth || 160,
          marginRight: 8
        },
        placeholder: this.props.inputPlaceHolder || "Please enter keywords",
        onChange: function onChange(e) {
          return _this2.handleSearchContentChange('searchValue', e, _this2.props.submit);
        },
        onPressEnter: function onPressEnter() {
          return _this2.props.submit(_this2.state.searchValue);
        },
        name: "fakepasswordremembered",
        value: this.state.searchValue
      }, this.props.searchProps)), this.props.hasNotSearchInput ? "" : /*#__PURE__*/React.createElement(_Button, {
        icon: "search",
        onClick: function onClick() {
          return _this2.props.submit(_this2.state.searchValue, _this2.state.searchValueOne);
        }
      }, "search"), this.props.hasSwitch ? /*#__PURE__*/React.createElement(_Switch, {
        style: {
          marginLeft: 8
        },
        checkedChildren: this.props.checkedChildren,
        unCheckedChildren: this.props.unCheckedChildren,
        checked: this.props.checked,
        onChange: this.props.handleSwitchtChange
      }) : "", this.props.hasSwitch ? this.props.switchName : "") : "", /*#__PURE__*/React.createElement(_Modal, null));
    }
  }]);
  return HeaderBar;
}(React.Component);
HeaderBar.defaultProps = {
  hasAdd: false,
  hasDelete: false,
  hasSearch: false,
  hasUpload: false,
  addBtnDisabled: false,
  extraSelectedKeys: [],
  selectedKeys: []
};
export default injectIntl(HeaderBar);